import { Box, Typography } from '@mui/material';
import { withSnackbar } from '../../../../utils/SnackbarHOC';
import { withRouter } from 'react-router-dom/cjs/react-router-dom';
import { commonGridSx, gridLocaleText, makeGridToolbar } from '../../../../utils/gridStyles';
import { DataGrid } from '../../../../components/SortableDataGrid/SortableDataGrid';

const CustomToolbar = makeGridToolbar('Tableau comparatif');

const cell = (p) => (
  <Typography sx={{ fontSize: '1rem', color: '#475569' }}>{p.value ?? '—'}</Typography>
);

const ComparativeTable = ({ showTsp, data, isLoading, index }) => {
  let columns;

  if (index === 0) {
    columns = [
      { field: 'nom', headerName: 'Talent Manager', flex: 1, minWidth: 160, renderCell: cell },
      { field: 'notes', headerName: 'Notes', width: 100, align: 'center', headerAlign: 'center', renderCell: cell },
      { field: 'nouvelles missions', headerName: 'Nouvelles Missions', width: 160, renderCell: cell },
      { field: 'TT', headerName: 'TT %', width: 90, align: 'center', headerAlign: 'center', renderCell: cell },
      { field: 'envois', headerName: 'Envois', width: 90, align: 'center', headerAlign: 'center', renderCell: cell },
      { field: 'signatures', headerName: 'SIGNATURES', width: 120, align: 'center', headerAlign: 'center', renderCell: cell },
      { field: 'TBD', headerName: 'TBD %', width: 90, align: 'center', headerAlign: 'center', renderCell: cell },
    ];
  } else {
    columns = [
      { field: 'nom', headerName: !showTsp ? 'CONSULTANTS' : 'CLIENTS', flex: 1, minWidth: 160, renderCell: cell },
      { field: 'Prequalif', headerName: 'ENVOIS', width: 90, align: 'center', headerAlign: 'center', renderCell: cell },
      { field: 'Envois client', headerName: 'RÉVÉLATIONS', width: 120, align: 'center', headerAlign: 'center', renderCell: cell },
      { field: 'tr', headerName: 'TR %', width: 90, align: 'center', headerAlign: 'center', renderCell: cell },
      { field: 'Propale', headerName: 'PROPALES', width: 100, align: 'center', headerAlign: 'center', renderCell: cell },
      { field: 'Embauche/Integration', headerName: 'SIGNATURES', width: 120, align: 'center', headerAlign: 'center', renderCell: cell },
      { field: 'ts', headerName: 'TS %', width: 90, align: 'center', headerAlign: 'center', renderCell: cell },
      ...(showTsp ? [{ field: 'tsp', headerName: 'TS/P %', width: 90, align: 'center', headerAlign: 'center', renderCell: cell }] : []),
    ];
  }

  const rows = (data || []).map((row, i) => ({ ...row, id: row.id ?? i }));

  return (
    <Box sx={{ borderRadius: 3, border: '1px solid #e2e8f0', height: '32vh', minHeight: 200, background: '#fff', overflow: 'hidden', display: 'flex', flexDirection: 'column', boxShadow: '0 1px 3px 0 rgb(0 0 0 / 0.04)', mt: '20px' }}>
      <DataGrid
        rows={rows}
        columns={columns}
        getRowId={(row) => row.id}
        loading={isLoading}
        pageSizeOptions={[50]}
        disableRowSelectionOnClick
        showToolbar
        slots={{ toolbar: CustomToolbar }}
        slotProps={{ loadingOverlay: { variant: 'skeleton', noRowsVariant: 'skeleton' } }}
        localeText={gridLocaleText}
        sx={commonGridSx}
      />
    </Box>
  );
};

export default withRouter(withSnackbar(ComparativeTable));
